
// import { useState, useEffect } from "react";
// import { Button, Modal } from "../../../../../../components";
// import AddAccountModel from "./AddAccountModel";
// import ProductivityModel from "./ProductivityModel";
// import { checkAdminAdded } from "../../../../../../redux/slices/setting/settingApi";

// const SetupModel = ({ onConnect, category, type }) => {
//   const [connectClicked, setConnectClicked] = useState(false);
//   const [integrationExists, setIntegrationExists] = useState(false);

//   const handleConnect = () => {
//     setConnectClicked(true);
//   };

//   const handleClose = () => {
//     setConnectClicked(false);
//   };

//   useEffect(() => {
//     const fetchIntegration = async () => {
//       try {
//         const res = await checkAdminAdded({
//           coll: "Integration",
//           fil: {
//             category: { type: "NONE", value: category },
//             type: { type: "NONE", value: type },
//           },
//         });

//         // If integration exists, set the flag
//         if (res?.data?.data && Object.keys(res.data.data).length > 0) {
//           setIntegrationExists(true);
//         }
//       } catch (err) {
//         console.error("Error checking integration", err);
//       }
//     };

//     fetchIntegration();
//   }, [category, type]);

//   return (
//     <div className="h-120">
//       <div className="border-1 border-gray-200 rounded-lg m-2 p-4 flex flex-col">
//         <h5>Steps of Instructions</h5>
//         <p className="mt-3">
//           Here are the steps to setup and integrate the external service.
//         </p>
//         <div className="self-end mt-10">
//           <Button
//             title={integrationExists ? "Integration Already Done" : "Connect"}
//             type="button"
//             onClick={handleConnect}
//             disabled={integrationExists} // Disable if integration exists
//           />
//         </div>
//       </div>

//       {connectClicked && !integrationExists && (
//         <Modal
//           isOpen={connectClicked}
//           onClose={handleClose}
//           title="Add Account"
//           width="max-w-4xl"
//           titleColor={"primary"}
//         >
//           {category === "Productivity" ? (
//             <ProductivityModel onCancel={handleClose} />
//           ) : (
//             <AddAccountModel
//               category={category}
//               type={type}
//               onCancel={handleClose}
//             />
//           )}
//         </Modal>
//       )}
//     </div>
//   );
// };

// export default SetupModel;

import { useState, useEffect } from "react";
import { Button, Modal } from "../../../../../../components";
import AddAccountModel from "./AddAccountModel";
import ProductivityModel from "./ProductivityModel";
import { checkAdminAdded } from "../../../../../../redux/slices/setting/settingApi";

const SetupModel = ({ onConnect, category, type, onClose }) => {
  const [connectClicked, setConnectClicked] = useState(false);
  const [integrationExists, setIntegrationExists] = useState(false);

  const handleConnect = () => {
    setConnectClicked(true);
  };

  const handleClose = () => {
    setConnectClicked(false);
  };
  const handleIntegrationAdded = () => {
    setConnectClicked(false); 
    if (onConnect) onConnect();
    if (onClose) onClose();
  };

  useEffect(() => {
    const fetchIntegration = async () => {
      try {
        const res = await checkAdminAdded({
          coll: "Integration",
          fil: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
        });

        
        if (
          // type === 1 &&
          res?.data?.data &&
          Object.keys(res.data.data).length > 0
        ) {
          setIntegrationExists(true);
        } else {
          setIntegrationExists(false);
        }
      } catch (err) {
        console.error("Error checking integration", err);
      }
    };

    fetchIntegration();
  }, [category, type]);

  return (
    <div className="h-120">
      <div className="border-1 border-gray-200 rounded-lg m-2 p-4 flex flex-col">
        <h5>Steps of Instructions</h5>
        <p className="mt-3">
          Here are the steps to setup and integrate the external service.
        </p>
        <div className="self-end mt-10">
          <Button
            title={
              integrationExists
                ? "Integration Already Done"
                : "Connect"
            }
            type="button"
            onClick={handleConnect}
            disabled={integrationExists} 
          />
        </div>
      </div>

      {connectClicked && (
        <Modal
          isOpen={connectClicked}
          onClose={handleClose}
          title="Add Account"
          width="max-w-4xl"
          titleColor="primary"
        >
          {category === "Productivity" ? (
            <ProductivityModel onCancel={handleClose} />
          ) : (
            <AddAccountModel
              category={category}
              type={type}
              onCancel={handleClose}
              onConnect={handleIntegrationAdded}
            />
          )}
        </Modal>
      )}
    </div>
  );
};

export default SetupModel;
